import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../../services/Api.js";


// export const postKiteData = createAsyncThunk('auth/postLoginData', () => {

//     const params = new URLSearchParams(window.location.search);
//     const clientId = "u72wg8ivj1l9xksf";
//     const request_token = params.has("request_token");
//     if (!request_token) {
//       const authUrl = `https://kite.trade/connect/login?v=3&api_key=${clientId}`;
//       window.location.href = authUrl;
//     }
//     return request_token;


// })





export const postLoginData = createAsyncThunk('auth/postLoginData', async (userData) => {
    try {
        const response = await apiServices.post('/identity/sign_in?broker=ZERODHA&request_token=', userData);
        console.log("response", response);

        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 1); // Set to expire in 1 day
        document.cookie = `authToken=${response?.access_token}; expires=${expirationDate.toUTCString()}; path=/`;
        localStorage.setItem("userID", response?.userId);

        return response;
    } catch (error) {
        console.error("Login error:", error);
        throw error;
    }
});

// get current user
export const getCurrentUser = createAsyncThunk("auth/getCurrentUser", async (id) => {
    try {
        const response = await apiServices.get(`/identity/users/${id}`);
        return response;
    } catch (error) {
        console.error("Error fetching current user:", error);
        throw error;
    }
});

//logout - Client-side only logout since no server logout endpoint exists
export const LogoutFunc = createAsyncThunk("auth/LogoutFunc", async () => {
    try {
        // Clear authentication data from localStorage and cookies
        localStorage.removeItem("userID");
        document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        return { success: true, message: "Logged out successfully" };
    } catch (error) {
        console.error("Error during logout:", error);
        throw error;
    }
});

export const verfiyUser = createAsyncThunk('auth/otp/verify', async({otp, mobileNumber}) => {
    try {
        const response = await apiServices.post('auth/otp/verify', { otp, phoneNumber: mobileNumber }, {});
        return response;
    } catch (error) {
        console.error("Error verifying user:", error);
        throw error;
    }
});

export const createUser = createAsyncThunk('auth/users', async({email,firstName, lastName, phoneNumber}) => {
    try {
        const response = await apiServices.post('users', {email,firstName, lastName, phoneNumber}, {});
        return response;
    } catch (error) {
        console.error("Error creating user:", error);
        throw error;
    }
});

const initialState = {
    auth: false,
    token: null,
    loading: false,
    error: "",
    user: [],
    userId: '',
    success: null,
    isLoggedIn: null,
    test: null,
    phoneNumber: null,  
};

const AuthSlice = createSlice({
    name: "auth",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(postLoginData.pending, (state) => {
                state.loading = true;
                state.auth = false;
            })
            .addCase(postLoginData.fulfilled, (state, action) => {
                state.auth = true;
                state.loading = false;
                state.user = [action?.payload?.firstName + " " + action?.payload?.lastName];
                state.userId = action?.payload?.userId;
                state.isLoggedIn = true;
                state.success = true;
                state.phoneNumber = action?.payload?.phoneNumber;
                console.log("state authentication", state);
            })
            .addCase(postLoginData.rejected, (state, action) => {
                state.loading = false;
                state.auth = false;
                state.error = action.error.message || "Login failed";
                state.isLoggedIn = false;
                state.success = false;
                console.log("Login error:", state.error);
            })
            .addCase(verfiyUser.pending, (state, _) => {
                state.loading = true;
                state.auth = false;
            })
            .addCase(verfiyUser.fulfilled, (state, action) => {
                state.auth = true;
                state.loading = false;
                state.user = [action?.payload?.user?.firstName + " " + action?.payload?.user?.lastName];
                state.userId = action?.payload?.user?.Id;
                state.isLoggedIn = action?.payload?.userExists;
                state.success = true;
                state.phoneNumber = action?.payload?.user?.phoneNumber;
                state.token = action?.payload?.token;
            })
            .addCase(verfiyUser.rejected, (state, action) => {
                state.loading = false;
                state.auth = false;
                state.error = action.error.message || "Verification failed";
                state.isLoggedIn = false;
                state.success = false;
                console.log("Verification error:", state.error);
            })
            // create User
            .addCase(createUser.pending, (state, _) => {
                state.loading = true;
                state.auth = false;
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.auth = true;
                state.loading = false;
                state.user = [action?.payload?.user?.firstName + " " + action?.payload?.user?.lastName];
                state.userId = action?.payload?.user?.Id;
                state.isLoggedIn = true;
                state.success = true;
                state.phoneNumber = action?.payload?.user?.phoneNumber;
                state.token = action?.payload?.token;
            })
            .addCase(createUser.rejected, (state, action) => {
                state.loading = false;
                state.auth = false;
                state.error = action.error.message || "User creation failed";
                state.isLoggedIn = false;
                state.success = false;
                console.log("User creation error:", state.error);
            })
            // get Current User
            .addCase(getCurrentUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCurrentUser.fulfilled, (state, action) => {
                state.loading = false;
                state.user = [action.payload];
            })
            .addCase(getCurrentUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch user data";
                state.user = [];
            })
            // logout
            .addCase(LogoutFunc.pending, (state) => {
                state.loading = true;
            })
            .addCase(LogoutFunc.fulfilled, (state, action) => {
                state.auth = false;
                state.loading = false;
                state.isLoggedIn = false;
                state.user = [];
                state.userId = '';
                state.token = null;
                state.phoneNumber = null;
            })
            .addCase(LogoutFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Logout failed";
            });
    },
});

const AuthReducer = AuthSlice.reducer;

export default AuthReducer;
